// import React, { useMemo, useState } from "react";
// import CardsBorder from "../../../components/Cards/CardsBorder";
// import { ReactComponent as GreenEye } from "../../../assets/svgs/greenEye.svg";
// import { ReactComponent as DeleteIcon } from "../../../assets/svgs/deleteIcon.svg";
// import { ReactComponent as DownloadIcon } from "../../../assets/svgs/downlaod.svg";
// import { ReactComponent as UploadIcon } from "../../../assets/svgs/upload.svg";
// import { Tables } from "../../../components/Elements/Tables/Tables";
// import { Button } from "antd";
// import SearchBar from "../../../components/Elements/Search/SearchBar";
// import TextStyles from "../../../components/Elements/TextStyles/TextStyles";
// import UploadNewReport from "../DailogBox/UploadNewReport";

// const Reports = () => {
//   const [searchItem, setSearchItem] = useState("");
//   const [openUploadNewReport, setOpenUploadNewReport] = useState(false);
//   const headers = useMemo(
//     () => [
//       { label: "Sr. No.", key: "serial" },
//       { label: "Reports", key: "reports" },
//       { label: "Action", key: "action" },
//     ],
//     []
//   );

//   const tableData = useMemo(() => [
//     {
//       serial: 1,
//       reports: "BRSR REPORT",
//       action: (
//         <div className="flex gap-2 items-center">
//           <GreenEye />
//           <DownloadIcon />
//           <UploadIcon onClick={() => setOpenUploadNewReport(true)} />
//           <DeleteIcon />
//         </div>
//       ),
//     },
//     {
//       serial: 2,
//       reports: "CARBON FOOTPRINT REPORT",
//       action: (
//         <div className="flex gap-2 items-center">
//           <GreenEye />
//           <DownloadIcon />
//           <UploadIcon onClick={() => setOpenUploadNewReport(true)} />
//           <DeleteIcon />
//         </div>
//       ),
//     },
//     {
//       serial: 3,
//       reports: "AUDIT REPORT",
//       action: (
//         <div className="flex gap-2 items-center">
//           <GreenEye />
//           <DownloadIcon />
//           <UploadIcon onClick={() => setOpenUploadNewReport(true)} />
//           <DeleteIcon />
//         </div>
//       ),
//     },
//   ]);

//   return (
//     <div>
//       <CardsBorder>
//         <div>
//           <div>
//             <div className="px-10 pb-4">
//               <div className="flex gap-16">
//                 <div className="flex items-center  gap-2 text-xl  font-bold">
//                   <TextStyles color="gradient">Reports</TextStyles>
//                 </div>
//                 <SearchBar
//                   width="400px"
//                   onSearch={(value) => {
//                     setSearchItem(value);
//                     console.log(searchItem);
//                   }}
//                 />
//               </div>
//             </div>
//             <Tables data={tableData} headers={headers} />
//           </div>
//         </div>
//       </CardsBorder>
//       {openUploadNewReport && (
//         <UploadNewReport
//           open={openUploadNewReport}
//           onCancel={() => setOpenUploadNewReport(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default Reports;

import React, { useMemo, useState, useEffect, useCallback } from "react";
import CardsBorder from "../../../components/Cards/CardsBorder";
import { ReactComponent as GreenEye } from "../../../assets/svgs/greenEye.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/svgs/deleteIcon.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/svgs/downlaod.svg";
import { ReactComponent as UploadIcon } from "../../../assets/svgs/upload.svg";
import { Tables } from "../../../components/Elements/Tables/Tables";
import { Button } from "antd";
import SearchBar from "../../../components/Elements/Search/SearchBar";
import TextStyles from "../../../components/Elements/TextStyles/TextStyles";
import UploadNewReport from "../DailogBox/UploadNewReport";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import { useLocation } from "react-router-dom";
import { deleteApi } from "../../../api/api_instance";
import { putApi } from "../../../api/api_instance";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";

const Reports = ({refresh}) => {
  const [searchItem, setSearchItem] = useState("");
  const [openUploadNewReport, setOpenUploadNewReport] = useState(false);
  const [tableData, setTableData] = useState([]);
  // const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  // ✅ Info popup (success / error)
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });

  // ✅ Confirmation popup (for delete)
  const [confirmPopup, setConfirmPopup] = useState({
    show: false,
    fileId: null,
  });

  const location = useLocation();
  const { reportId } = location.state || {};
  const [reportName, setReportName] = useState("");

  const triggerPopup = (type, title, message, duration = 3000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), duration);
  };

  const headers = useMemo(
    () => [
      { label: "#", key: "serial", textAlign: "center" },
      { label: "Reports", key: "reports", textAlign: "center" },
      { label: "Action", key: "action", textAlign: "center" },
    ],
    []
  );

  // ✅ Preview file
  const handlePreview = async (viewUrl, fileName) => {
    if (!viewUrl) {
      triggerPopup("warning", "Preview Unavailable", "Preview not available for this report.");
      return;
    }

    try {
      window.open(viewUrl, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Preview error:", error);
      triggerPopup("error", "Error", "Unable to preview the file. The link may have expired.");
    }
  };

  // ✅ Download file
  const handleDownload = async (viewUrl, fileName) => {
    if (!viewUrl) {
      triggerPopup("warning", "Download Unavailable", "Download not available for this report.");
      return;
    }

    try {
      const response = await fetch(viewUrl);
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName || "report.pdf";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();

      setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }, 100);

      console.log("Download completed!");
    } catch (error) {
      console.error("Download failed:", error);
      try {
        const link = document.createElement("a");
        link.href = viewUrl;
        link.download = fileName || "report.pdf";
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (fallbackError) {
        triggerPopup("error", "Error", "Unable to download. Please try opening manually.");
      }
    }
  };

  // ✅ Upload handler
  const handleUpload = (report) => {
    setSelectedReport(report);
    setOpenUploadNewReport(true);
  };

  // ✅ Step 1: Show confirmation popup
  const handleDelete = (fileId) => {
    setConfirmPopup({ show: true, fileId });
  };

  // ✅ Step 2: Confirm delete (API call)
  const confirmDelete = async (fileId) => {
    if (!reportId || !fileId) {
      triggerPopup("error", "Error", "Missing report ID or file ID");
      return;
    }

    try {
      const res = await deleteApi({
        apiUrl: API_URLS.DELETE_REPORT_REQUEST(reportId, fileId),
      });

      if (res?.success) {
        triggerPopup("success", "Deleted", "Report deleted successfully!");
        fetchReports(); // refresh list
      } else {
        triggerPopup("error", "Failed", res?.message || "Failed to delete report");
      }
    } catch (error) {
      console.error("Delete error:", error);
      triggerPopup("error", "Error", "Error deleting report");
    } finally {
      setConfirmPopup({ show: false, fileId: null });
    }
  };

  // ✅ Step 3: Cancel delete
  const cancelDelete = () => {
    setConfirmPopup({ show: false, fileId: null });
  };

  // ✅ Fetch reports
  const fetchReports = useCallback(async () => {
    if (!reportId) return;
    setLoading(true);
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_CUSTOMER_REPORT_DETAILS(reportId),
      });

      if (response?.data) {
        const reportMainName = response.data.reports?.fileName || null;
        setReportName(reportMainName);
        const reportsArray = response.data.reports || [];

        if (reportsArray.length >= 0) {
          const mappedData = reportsArray.map((item, index) => ({
            key: item._id,
            serial: <div className="text-center">{index + 1}</div>,
            reports: <div className="text-center">{item.fileName || "N/A"}</div>,
            action: (
              <div className="flex gap-2 items-center justify-center">
                <GreenEye
                  className="cursor-pointer hover:opacity-70"
                  onClick={() => handlePreview(item.viewUrl, item.fileName)}
                  title="Preview"
                />
                <DownloadIcon
                  className="cursor-pointer hover:opacity-70"
                  onClick={() => handleDownload(item.viewUrl, item.fileName)}
                  title="Download"
                />
                <UploadIcon
                  className="cursor-pointer hover:opacity-70"
                  onClick={() => handleUpload(item)}
                  title="Upload New Version"
                />
                <DeleteIcon
                  className="cursor-pointer hover:opacity-70"
                  onClick={() => handleDelete(item._id)}
                  title="Delete"
                />
              </div>
            ),
            originalData: item,
          }));

          setTableData(mappedData);
        } else {
          setTableData([
            {
              key: response.data._id,
              serial: <div className="text-center">1</div>,
              reports: <div className="text-center">{reportMainName}</div>,
              action: (
                <div className="flex gap-2 items-center justify-center">
                  <UploadIcon
                    className="cursor-pointer hover:opacity-70"
                    onClick={() => handleUpload({ name: reportMainName })}
                    title="Upload Report"
                  />
                </div>
              ),
            },
          ]);
        }
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
      setTableData([]);
    } finally {
      setLoading(false);
    }
  }, [reportId]);

  useEffect(() => {
    if (reportId) fetchReports();
  }, [fetchReports, reportId, refresh]);

  // ✅ Filter search
  const filteredData = useMemo(() => {
    if (!searchItem) return tableData;
    return tableData.filter((item) =>
      (item.originalData?.fileName || "").toLowerCase().includes(searchItem.toLowerCase())
    );
  }, [tableData, searchItem]);

  return (
    <div>
      <CardsBorder>
        <div className="px-10 pb-4">
          <div className="flex gap-16">
            <div className="flex items-center gap-2 text-xl font-bold">
              <TextStyles color="gradient">Reports</TextStyles>
            </div>
            <SearchBar
              width="400px"
              onSearch={(value) => setSearchItem(value)}
            />
          </div>
        </div>
        <Tables data={filteredData} headers={headers} loading={loading} />
      </CardsBorder>

      {/* ✅ Upload New Report Popup */}
      {openUploadNewReport && (
        <UploadNewReport
          open={openUploadNewReport}
          onCancel={() => {
            setOpenUploadNewReport(false);
            setSelectedReport(null);
          }}
          selectedReport={selectedReport}
          reportId={reportId}
          onUploadSuccess={fetchReports}
        />
      )}


      {showPopup && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
          />
        </div>
      )}

      {/* ✅ Delete Confirmation Popup */}
      {confirmPopup.show && (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black bg-opacity-40">
          <PopupCard
            type="warning"
            title="Confirm Delete"
            message="Are you sure you want to delete this report?"
            showActions={true}
            cancelText="Cancel"
            confirmText="Delete"
            onCancel={cancelDelete}
            onConfirm={() => confirmDelete(confirmPopup.fileId)}
          />
        </div>
      )}

    </div>
  );
};

export default Reports;